module.exports = __webpack_public_path__ + "4f0a6f429d069e70c6d626089d1c089f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/MainMenu/MenuPartyPlatters.png
// module id = 408
// module chunks = 0